export enum EBookingRestriction {
  MultipleProducts = 'multipleProducts',
  SingleProduct = 'singleProduct',
  SingleTicketType = 'singleTicketType'
}
